import moment from 'moment'
import { GraviGrid, Horizontal } from '@gravitate-js/excalibrr'
import { getColumnDefs } from '../columnDefs'
import { useAnalyticsReporting } from '@api/useAnalyticsReporting'
import { useUserSettings } from '@hooks/settings'
import { DateRangeFilter } from '@components/_SiteWide/Grid/ActionButtons/DateRangeFilter'
import { useMemo, useRef } from 'react'
import { useDateRangeFilter } from '@hooks/useDateRangeFilter'
import { DownloadButton } from '@components/_SiteWide/Grid/ActionButtons/DownloadButton'

export function BOLTransactions() {
  const gridAPIRef = useRef(null)
  const { useBOLTransactionsOverview, useRecalculateBOLsMutation } = useAnalyticsReporting()
  const recalculate = useRecalculateBOLsMutation()
  const { updateSetting } = useUserSettings()
  const columnDefs = useMemo(() => getColumnDefs('bol-transactions', recalculate), [])

  const { filters, setFilters, dayRangeStorage, setDayRange } = useDateRangeFilter(
    'analytics-reporting-bol-transactions-dates',
    {
      back: -3,
      ahead: 3,
    }
  )

  const { data, isFetching } = useBOLTransactionsOverview({
    start: moment(filters.From).format('YYYY-MM-DDT00:00:00'),
    end: moment(filters.To).format('YYYY-MM-DDT00:00:00'),
  })

  return (
    <GraviGrid
      storageKey='bol-transactions'
      rowData={data?.rows ?? []}
      loading={isFetching}
      columnDefs={columnDefs}
      externalRef={gridAPIRef}
      primaryKey='id'
      controlBarProps={{
        title: 'BOL Transactions',
        actionButtons: (
          <Horizontal verticalCenter gap='1em'>
            <DateRangeFilter
              getFromStorage
              currentFilters={filters}
              setCurrentFilters={setFilters}
              dayRangeStorage={dayRangeStorage}
              setDayRangeStorage={setDayRange}
              defaultSliderValues={[-3, 3]}
            />
            <DownloadButton fileName='BOL Transactions' gridAPIRef={gridAPIRef} />
          </Horizontal>
        ),
      }}
      agPropOverrides={{
        getRowId: (row) => row?.data?.key ?? row?.data?.order_id + '_' + row?.data?.bol_number,
      }}
      onGridConfigChanged={(config) => updateSetting('gridConfig::bol-transactions', config)}
    />
  )
}
